import { Component, Binding } from '../annotations';

@Component({
	selector: 'panel',
	template: require('./panel.html'),
	style: require('./panel.scss'),
	transclude: {
		title: '?panelTitle',
		body: '?panelBody'
	}
})
export class Panel {
	@Binding('@') image: string;
	@Binding('<') speed: number;
	@Binding('<') fullScreen: boolean;
}


/** WEBPACK FOOTER **
 ** ./app/common/panel.ts
 **/